// arkit project API key
// https://console.cloud.google.com/apis/credentials/key/43ff8952-a46e-4834-ab2d-687c8076f04b?project=arkit-js
const key = 'AIzaSyBzuIXNXJ-lN7VHFzQL1E25sbR-z_n3x9Q';

export const googleMapsURL = `https://maps.googleapis.com/maps/api/js?key=${key}`;

export const googleGeolocationURL = `https://www.googleapis.com/geolocation/v1/geolocate?key=${key}`;
